import {
    HttpInterceptorFn,
    HttpRequest,
    HttpHandlerFn,
} from '@angular/common/http';
import { timeout } from 'rxjs/operators';

export const timeoutInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn) => next(req).pipe(timeout(20000));
